/**
 * @module 金可花iOS相关模块路由
 */
export default [
  // 我的客服 - 审核中
  {
    path: '/jkh/mine/service',
    name: 'jkh_mine_service',
    component: () => import('@/pages/app/jkh-app/mine/service.vue'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/jkh/protocol/register',
    name: 'jkh_protocol_register',
    component: () => import('@/pages/app/jkh-app/protocol/register.vue'),
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/jkh/protocol/private',
    name: 'jkh_protocol_private',
    component: () => import('@/pages/app/jkh-app/protocol/private.vue'),
    meta: {
      title: '用户隐私保护政策'
    }
  }
]
